type MarketplaceVisibleEvent = {
  status?: string | null;
  end_date?: string | null;
  is_active?: boolean | null;
};

export function isMarketplaceVisibleEvent(event: MarketplaceVisibleEvent): boolean {
  if (event.is_active === false) return false;

  if (String(event.status ?? '').trim().toLowerCase() === 'ended') {
    return false;
  }

  if (event.end_date) {
    const endTime = new Date(event.end_date).getTime();
    if (!Number.isNaN(endTime) && endTime < Date.now()) {
      return false;
    }
  }

  return true;
}
